export const DEAL_LABEL = 'deal';
export const CATALOGUE_OFFER_TOOLTIP = 'CatalogueOfferTooltip';
export const LABEL_OFFER = 'LabelOffer';
export const LABEL_NEW = 'LabelNew';
export const LABEL_SUPER_DEAL = 'LabelSuperDeal';
export const NEW_EDITION_LABEL = 'new-edition';
export const NEW_EDITION_AVAILABLE_LABEL = 'new-edition-available';
export const OFFER = 'Offer';
export const NEW = 'New';
export const SUPER_DEAL = 'SuperDeal';
export const NEW_EDITION = 'NewEdition';
export const NEW_EDITION_AVAILABLE = 'NewEditionAvailable';
//# sourceMappingURL=dealLabel.js.map